/**
 * 导航头-方案hover弹窗（无TABS）
 */

import React, { Component } from 'react';
import { Row, Col } from 'antd';
// import Link from 'next/link';
import './index.less';

class NewPopWithoutTabs extends Component {

  constructor(props) {
    super(props);
    this.state = {
        maxContentHight: 356, //最大高度
    }
  }

    componentDidMount() {
        this.watchWindowSize()
        window.addEventListener('resize', this.watchWindowSize)
    }
    watchWindowSize = () => {
        let h = document.documentElement.clientHeight * 0.8
        this.setState({
            maxContentHight: h > 300 ? h : 300
        })
        console.log(h)
    }

  render() {
    const { style = {}, title = "", data= [] } = this.props
    const { maxContentHight } = this.state

    return (
    <div style={style} className="NewPopWithoutTabs">
        <Row gutter={20} style={{width:'100%'}}>
            <div className='NewPopWithoutTabs-content' style={{maxHeight: (maxContentHight - 64) + 'px'}}>
                <Col span={4}>
                    {(data[0].list)&&data[0].list.map((item, index)=>{
                        return <div key={'one' + index} className='NewPop-content-item'>
                                <div className='sub-item'>
                                    <div className='content-item-title'>{item.title}</div>
                                    <div className='sub-item-content'>
                                        <div className='sub-item-content-rank'>
                                            {item.subList.map((subItem,subIndex)=>{
                                                if(subItem.href.startsWith('http') || subItem.target == '_blank'){
                                                    return <a target={subItem.target ||"_self"} href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                                }
                                                return <a href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                            })}
                                        </div>
                                    </div>
                                    
                                </div>
                        </div>
                    })}
                </Col>
                <Col span={4}>
                    {(data[0].list2)&&data[0].list2.map((item, index)=>{
                        return <div key={'two' + index} className='NewPop-content-item'>
                                <div className='sub-item'>
                                    <div className='content-item-title'>{item.title}</div>
                                    <div className='sub-item-content'>
                                        <div className='sub-item-content-rank'>
                                            {item.subList.map((subItem,subIndex)=>{
                                                if(subItem.href.startsWith('http') || subItem.target == '_blank'){
                                                    return <a target={subItem.target ||"_self"} href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                                }
                                                return <a href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                            })}
                                        </div>
                                    </div>
                                    
                                </div>
                        </div>
                    })}
                </Col>
                <Col span={4}>
                    {(data[0].list3)&&data[0].list3.map((item, index)=>{
                        return <div key={'three' + index} className='NewPop-content-item'>
                                <div className='sub-item'>
                                    <div className='content-item-title'>{item.title}</div>
                                    <div className='sub-item-content'>
                                        <div className='sub-item-content-rank'>
                                            {item.subList.map((subItem,subIndex)=>{
                                                if(subItem.href.startsWith('http') || subItem.target == '_blank'){
                                                    return <a target={subItem.target ||"_self"} href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                                }
                                                return <a href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                            })}
                                        </div>
                                    </div>
                                    
                                </div>
                        </div>
                    })}
                </Col>
                <Col span={4}>
                    {(data[0].list4)&&data[0].list4.map((item, index)=>{
                        return <div key={'four' + index} className='NewPop-content-item'>
                                <div className='sub-item'>
                                    <div className='content-item-title'>{item.title}</div>
                                    <div className='sub-item-content'>
                                        <div className='sub-item-content-rank'>
                                            {item.subList.map((subItem,subIndex)=>{
                                                if(subItem.href.startsWith('http') || subItem.target == '_blank'){
                                                    return <a target={subItem.target ||"_self"} href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                                }
                                                return <a href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                            })}
                                        </div>
                                    </div>
                                    
                                </div>
                        </div>
                    })}
                </Col>
                <Col span={4}>
                    {(data[0].list5)&&data[0].list5.map((item, index)=>{
                        return <div key={'five' + index} className='NewPop-content-item'>
                                <div className='sub-item'>
                                    <div className='content-item-title'>{item.title}</div>
                                    <div className='sub-item-content'>
                                        <div className='sub-item-content-rank'>
                                            {item.subList.map((subItem,subIndex)=>{
                                                if(subItem.href.startsWith('http') || subItem.target == '_blank'){
                                                    return <a target={subItem.target ||"_self"} href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                                }
                                                return <a href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                            })}
                                        </div>
                                    </div>
                                    
                                </div>
                        </div>
                    })}
                </Col>
                <Col span={4}>
                    {(data[0].list6)&&data[0].list6.map((item, index)=>{
                        return <div key={'six' + index} className='NewPop-content-item'>
                                <div className='sub-item'>
                                    <div className='content-item-title'>{item.title}</div>
                                    <div className='sub-item-content'>
                                        <div className='sub-item-content-rank'>
                                            {item.subList.map((subItem,subIndex)=>{
                                                if(subItem.href.startsWith('http') || subItem.target == '_blank'){
                                                    return <a target={subItem.target ||"_self"} href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                                }
                                                return <a href={subItem.href}><div className='content-sublist-item'>{subItem.title}</div></a>
                                            })}
                                        </div>
                                    </div>
                                    
                                </div>
                        </div>
                    })}
                </Col>  
            </div>
        </Row>
        
    </div>
    )
  }
}

export default NewPopWithoutTabs;
 